import { HostListener } from "@angular/core";
import { Subject } from "rxjs";

export class DropdownContainer {

    keyPress: Subject<KeyboardEvent>;

    constructor() {
        this.keyPress = new Subject<KeyboardEvent>();
    }

    @HostListener('keydown', ['$event'])
    onArrowPressed($event: KeyboardEvent): void {
        this.keyPress.next($event);
    }
}
